import { FC } from 'react';
import { Trans, useTranslation } from '@frontend/i18n';
import { Text, TextLink } from '@frontend/design-system';
import { containerStyle } from './usage-terms.style';

const UsageTerms: FC = () => {
  const { t } = useTranslation('forms');

  return (
    <Text as='ol' css={containerStyle}>
      <Trans t={t}>
        <li>
          You agree to the Weave Digital Forms{' '}
          <TextLink to='https://www.getweave.com/legal/digital-forms-terms/' target='_blank'>
            Terms of Use
          </TextLink>{' '}
          (&quot;Terms&quot;). As part of these Terms you acknowledge and agree that you have exclusive control over and
          responsibility for the content, quality, and format of any form created or processed through the Forms Service
          (&quot;Forms&quot;). You are solely responsible for thoroughly reviewing and editing Forms as needed prior to
          use and for determining whether such Forms meet your requirements and needs. It is your responsibility to
          ensure that all Forms meet applicable legal requirements.
        </li>
        <li>
          You acknowledge and agree that you are solely responsible to ensure that any language translation of this form
          template is accurate and meets your requirements. Weave is not liable for any errors, omissions, or
          ambiguities in the translation of any digital form template.
        </li>

        <li>
          You acknowledge and agree that you are solely responsible to thoroughly review and edit the language of this
          form template prior to use to meet your requirements and applicable legal requirements.
        </li>
      </Trans>
    </Text>
  );
};

export default UsageTerms;
